export default __webpack_public_path__ + "static/media/norway.6db693ee.svg";